import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../apiServices/axios';
import { IRL_DOC, SAS_API, DATAROOM_SHARE, DATAROOM_SHARED_RESOLVE } from '../apiServices/api_routes';
import { toast } from 'react-toastify';
const checkStatus = Data => {
    if (Data?.length === 0) {
        return 'pending';
    }
    return 'completed';
};
export const GetIRLDoc = createAsyncThunk('IRLDOC/getIRLDoc', async id => id && (await axiosInstance.get(`${IRL_DOC}${localStorage['project_id']}/${id}`)));
export const GetPopulateDownloadBy = createAsyncThunk(
    'IRLDOC/GetPopulateDownloadBy',
    async ({ id, wsId }) => await axiosInstance.get(`${IRL_DOC}${localStorage['project_id']}/${wsId}/${id}/download`),
);

export const GetSingleIRLDoc = createAsyncThunk('IRLDOC/getSingleIRLDoc', async ({ wsId, docId }) => {
    const data = await axiosInstance.get(IRL_DOC + localStorage['project_id'] + '/' + wsId + '/' + docId);
    return data;
});
export const GetIRLDocData = createAsyncThunk('IRLDOC/getIRLDocData', async ({ id, workstream }) => {
    const data = await axiosInstance.get(IRL_DOC + localStorage['project_id'] + '/' + workstream + '/' + id + '/');
    return data;
});

export const GetDocumentShareLink = createAsyncThunk(
    'IRLDOC/getDocumentShareLink',
    async (documentId, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get(DATAROOM_SHARE, {
                params: { document_id: documentId },
            });
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    },
);

export const CreateDocumentShareLink = createAsyncThunk(
    'IRLDOC/createDocumentShareLink',
    async (documentId, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post(DATAROOM_SHARE, {
                document_id: documentId,
            });
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    },
);

export const ResolveDocumentShareLink = createAsyncThunk(
    'IRLDOC/resolveDocumentShareLink',
    async (shareId, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get(`${DATAROOM_SHARED_RESOLVE}${shareId}/`);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    },
);

export const GetAuthenticatedDocUrl = createAsyncThunk('IRLDOC/getAuthenticatedDocUrl', async (docUrl, { rejectWithValue }) => {
    try {
        // Get short-lived SAS token (15 minutes expiry, read-only)
        const response = await axiosInstance.post(SAS_API, null, {
            params: { ProjectImg: docUrl },
        });
        return response.data?.image || docUrl;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

export const PostIRLDocuments = createAsyncThunk('POST_IRL_DOC', async ({ body, ws_id }, { rejectWithValue }) => {
    try {
        const data = await axiosInstance.post(IRL_DOC + localStorage['project_id'] + '/' + ws_id + '/', body);
        return data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

export const PostFolderDocuments = createAsyncThunk('POST_FOLDER_DOC', async ({ body, ws_id }, { rejectWithValue }) => {
    try {
        const projectId = localStorage.getItem('project_id');
        const url = `${IRL_DOC}${projectId}/${ws_id}/bulk_folder_upload/`;
        const response = await axiosInstance.post(url, body);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

export const PatchRLDocuments = createAsyncThunk('PATCH_IRL_DOC', async body => {
    const data = await axiosInstance.patch(IRL_DOC + body?.id + '/?project_id=' + localStorage['project_id'], body);
    return data;
});
export const DeleteBulkFiles = createAsyncThunk('DELETE_BULK_IRL_DOC', async ({ ws_id, items }, { rejectWithValue }) => {
    try {
        const data = await axiosInstance.post(IRL_DOC + localStorage['project_id'] + '/' + ws_id + '/bulk_delete/', { items });
        return data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

export const documentsSlice = createSlice({
    name: 'documentsSlice',
    initialState: {
        loading: true,
        data: [],
        status: '',
        errorMessage: '',
        error: false,
        docCounts: null,
        bulkFilesLoading: false,
    },
    reducers: {
        setDocs: (state, { payload }) => {
            return { ...state, status: checkStatus(payload), data: payload };
        },
        resetDocumentData: (state, { payload }) => {
            return { loading: true, data: [], status: '', errorMessage: '', error: false, docCounts: null, bulkFilesLoading: false };
        },
        addDoc: (state, { payload }) => {
            return {
                ...state,
                status: checkStatus([payload]),
                data: [...state.data, payload],
            };
        },
    },
    extraReducers: {
        [GetIRLDoc.fulfilled]: (state, { payload }) => {
            state.data = payload?.data?.documents || [];
            state.docCounts = payload?.data?.doc_count;
            state.status = checkStatus(payload?.data);
            state.loading = false;
        },
        [GetIRLDoc.rejected]: (state, action) => {
            state.error = true;
            state.errorMessage = action?.error?.message;
            state.data = [];
            state.loading = false;
        },

        //GetIRLDocData
        [GetIRLDocData.fulfilled]: (state, { payload }) => {
            state.data = state.data?.map(item => {
                if (item?.id === payload?.data?.id) return payload?.data;
                else return item;
            });
        },
        [GetIRLDocData.rejected]: (state, action) => {
            console.log({ action });
        },

        // PostIRLDocuments
        [PostIRLDocuments.fulfilled]: (state, { payload, meta }) => {
            state.loading = false;
            let data = payload?.data?.document_link ? [payload.data] : payload?.data;
            if (state?.data && state?.data?.length > 0) state.data = [...state.data, ...data];
            else state.data = data;
        },
        [PostIRLDocuments.rejected]: (state, { payload }) => {
            // Object.values(payload).map(value => {
            //     value?.forEach(msg => toast.error(msg));
            // });
            state.error = true;
        },
        // PatchRLDocuments
        [PatchRLDocuments.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = state?.data?.map(item => {
                if (item?.id === payload?.data?.id) return payload?.data;
                else return item;
            });
        },
        [PatchRLDocuments.rejected]: (state, action) => {
            state.error = true;
        },
        //DeleteBulkFiles
        [DeleteBulkFiles.pending]: (state, action) => {
            state.status = 'loading';
            state.bulkFilesLoading = true;
        },
        [DeleteBulkFiles.fulfilled]: (state, action) => {
            console.log(action);
            const ids = action?.meta?.arg?.items;
            state.data = state.data.filter(item => {
                let check = ids.find(id => Number(id) === item?.id);
                if (!check) return item;
            });
            state.status = 'success';
            state.bulkFilesLoading = false;
            toast.success('Successfully Deleted');
        },
        [DeleteBulkFiles.rejected]: (state, action) => {
            state.status = 'rejected';
            state.bulkFilesLoading = false;
            console.log({ action });
            const errorMessage = action?.payload?.detail || action?.payload?.message || action?.error?.message || 'Failed to delete documents';
            toast.error(errorMessage);
        },
        // GetPopulateDownloadBy
        [GetPopulateDownloadBy.fulfilled]: (state, action) => {
            console.log({ action });
        },
        // PostFolderDocuments
        [PostFolderDocuments.pending]: (state, action) => {
            state.bulkFilesLoading = true;
        },
        [PostFolderDocuments.fulfilled]: (state, action) => {
            state.bulkFilesLoading = false;
            if (state.data?.length > 0) {
                state.data = [...state.data, ...action?.payload];
            } else {
                state.data = action.payload;
            }
        },
        [PostFolderDocuments.rejected]: (state, action) => {
            state.bulkFilesLoading = false;
            // Check if it's a duplicate folder error
            if (action?.payload?.non_field_errors && action.payload.non_field_errors.some(error => error.includes('The fields workstream, name must make a unique set'))) {
                toast.error('Folder not added - a folder with this name already exists in the workstream.');
            } else {
                toast.error('Failed to upload folder');
            }
        },
    },
});

export const { setDocs, addDoc, resetDocumentData } = documentsSlice.actions;
export default documentsSlice.reducer;
